// profiles.store.js
import { observable } from "mobx";

import { axios } from "../../utils/axios";

class Subscription {
    @observable slug: string;
    @observable title: string;
    @observable cost: number;
    @observable monthlyCost: number;

    constructor(slug: string, title: string, cost: number, monthlyCost: number) {
        this.slug = slug;
        this.title = title;
        this.cost = cost / 100;
        this.monthlyCost = monthlyCost / 100;
    }
}

export default class BillingStore {
    @observable clientSecret = undefined;
    @observable subscriptionType: string = "MONTHLY";
    @observable metadata = null;
    @observable processing = false;
    @observable succeeded = false;
    @observable error: string = "";
    @observable loadingError: boolean = false;
    @observable successMessage: string = "";
    @observable currency: string = "USD";
    @observable subscriptions: Array<Subscription> = [];
    @observable monthlyRate: string = "";
    @observable amount: number = 0;

    rootStore: any;

    constructor(rootStore: any) {
        this.rootStore = rootStore;
    }

    getPublicStripeKey(options?: any) {
        return axios()
            .get(`/stripe/public-key`)
            .then((res: any) => {
                if (res.status === 200) {
                    return res.data;
                } else {
                    return null;
                }
            })
            .then((data: any) => {
                console.log(`Returning Stripe Public Key ${data.publicKey}`);
                if (!data || data.error) {
                    throw Error("API Error");
                } else {
                    return data.publicKey;
                }
            }).catch((err: any) => {
                console.log(`Error Loading Stripe Page ${err}`);
                this.loadingError = true;
                this.error = "There was a problem loading the billing page, please refresh to try again."
            })
    }

    setSubscription(subscription_slug: string) {
        this.processing = true;
        this.subscriptionType = subscription_slug;
        this.subscriptions.forEach(subscription => {
            if (subscription.slug == this.subscriptionType) {
                this.monthlyRate = `$${subscription.monthlyCost} / month`;
                this.amount = subscription.cost;
            }
        });
        this.processing = false;
    }

    fetchProductDetails() {
        var store = this;
        if (store.subscriptions.length == 0) {
            return axios()
                .get("/stripe/products")
                .then(function(res: any) {
                    return res.data.products;
                })
                .then(function(resData: any) {
                    store.subscriptions = [];
                    resData.forEach((subscription: any) => {
                        store.subscriptions.push(
                            new Subscription(
                                subscription.slug,
                                subscription.title,
                                subscription.cost,
                                subscription.monthly_cost
                            )
                        );
                    });
                    store.setSubscription(store.subscriptions[0].slug);
                }).catch(() => {
                    this.loadingError = true;
                    this.error = "There was a problem loading the billing page, please refresh to try again."
                })
            }
    }

    async confirmCardPayment(stripe: any, subscription: any) {
        const { latest_invoice } = subscription;
        const { payment_intent } = latest_invoice;

        const { client_secret, status } = payment_intent;
        const store = this;

        if (status !== "requires_action") {
            this.successMessage = "Subscription payment successful";
            return this.succeeded = true;
        }

        stripe.confirmCardPayment(client_secret).then(function(result: any) {
            if (result.error) {
                console.log(result.error);
                store.error = result.error;
                return (store.succeeded = false);
            }
            store.successMessage = "Subscription payment successful";
            store.succeeded = true;
        });
    }

    async stripePaymentMethodHandler(stripe: any, result: any) {
        this.processing = true;
        const store = this;
        if (result.error) {
            console.log(result.error);
            this.error = result.error;
        } else {
            // Otherwise send paymentMethod.id to your server
            return axios()
                .post("/stripe/payment-info", {
                        payment_method: result.paymentMethod.id,
                        subscription_type: store.subscriptionType
                })
                .then(function(result: any) {
                    return result.data;
                })
                .then(async function(customer: any) {
                    await store.confirmCardPayment(
                        stripe,
                        customer.subscription
                    );
                    store.processing = false;
                })
                .catch(function(err: any) {
                    store.error = err;
                    store.processing = false;
                });
        }
    }

    async createPaymentMethod(stripe: any, card: any) {
        console.log(`Sending payment method with e-mail ${this.rootStore.profileStore.profile.email}`);

        const result = await stripe.createPaymentMethod({
            type: "card",
            card: card,
            billing_details: {
                email: this.rootStore.profileStore.profile.email
            }
        });

        await this.stripePaymentMethodHandler(stripe, result);
    }
}
